export default {
  initialColorMode: 'light' as 'light',
  // initialColorMode: 'dark' as 'dark',
  useSystemColorMode: true,
}
